import React, { memo } from 'react';
import metadata from 'lib/metadata';

export default memo(({ width = '250px' }) => {
    return <img alt="Logo" width={width} src={metadata.logo} />;
});
